// extracted by mini-css-extract-plugin
module.exports = {"homepageHero":"HomepageHero_homepageHero__aGeK3","promoHero":"HomepageHero_promoHero__9iJH6","main-heading":"HomepageHero_main-heading__1oIUM"};